// Le CMS et le site public partagent ces fichiers versionnés dans le dépôt.

// 1. Importation des configurations fixes et options de formulaires
export const categories = [
  { id: "all", name: "Toutes" },
  { id: "theme", name: "Cake design à thème" },
  { id: "layer", name: "Layer cake" },
  { id: "number_letter", name: "Number/letter cake" },
  { id: "cupcakes_entremets", name: "Cupcakes et entremets" },
  { id: "wedding", name: "Pièces montées et wedding cakes" },
];

let localContactInfo = {
  email: "",
  phone: "",
  address: "",
  instagram: "",
  facebook: "",
  hours: { weekdays: "", saturday: "", sunday: "" },
};
try {
  const contactContent = require("./content/contact.json");
  const contactData = contactContent && typeof contactContent === "object"
    ? contactContent
    : {};
  const contactHours = contactData.hours && typeof contactData.hours === "object"
    ? contactData.hours
    : {};

  localContactInfo = {
    ...localContactInfo,
    ...contactData,
    hours: {
      weekdays: typeof contactHours.weekdays === "string" ? contactHours.weekdays : "",
      saturday: typeof contactHours.saturday === "string" ? contactHours.saturday : "",
      sunday: typeof contactHours.sunday === "string" ? contactHours.sunday : "",
    },
  };
} catch (e) {
  console.log("Coordonnées du site non configurées");
}
export const contactInfo = localContactInfo;

export const orderFormOptions = {
  cakeTypes: ["Wedding Cake", "Layer Cake", "Number Cake", "Letter Cake", "Cupcakes", "Gâteau Anniversaire", "Gâteau Baptême", "Gâteau Baby Shower", "Autre"],
  flavors: ["Vanille", "Chocolat", "Fraise", "Citron", "Red Velvet", "Pistache", "Caramel", "Fruits exotiques", "Autre"],
  servings: ["6-10 personnes", "10-15 personnes", "15-20 personnes", "20-30 personnes", "30-50 personnes", "50+ personnes"],
};

// Chargement des contenus JSON modifiés via le CMS.
const importAll = (context, directory) => context
  .keys()
  .filter((key) => key.startsWith(`./${directory}/`))
  .map((key) => ({
    id: key.replace(`./${directory}/`, "").replace(/\.json$/, ""),
    ...context(key),
  }))
  .sort((a, b) => (a.title || a.name || "").localeCompare(b.title || b.name || "", "fr"));

// Chargement de l'accueil
let localAbout = { title: "Bienvenue", description: "", cta: "" };
let localHero = [];
try {
  const aboutContent = require("./content/about.json");
  if (aboutContent && typeof aboutContent === "object") {
    localAbout = { ...localAbout, ...aboutContent };
  }
} catch (e) {
  console.log("Utilisation des données par défaut pour l'accueil");
}
try {
  const slides = require("./content/hero.json").slides;
  localHero = Array.isArray(slides)
    ? slides.filter((slide) => slide && typeof slide === "object").map((slide, index) => ({
      id: slide.id || `hero-${index + 1}`,
      ...slide,
    }))
    : [];
} catch (e) {
  console.log("Bannière d'accueil indisponible, affichage du visuel par défaut");
}
export const aboutText = localAbout;
export const heroSlides = localHero;

// Chargement automatique des listes (Tarifs, Avis, Réalisations)
let localTarifs = [];
let localTestimonials = [];
let localRealisations = [];

try {
  // Le contexte est créé sur le dossier content, qui existe toujours. Les
  // sous-dossiers peuvent être absents quand une collection CMS est vide.
  const contentFiles = require.context("./content", true, /\.json$/);
  localTarifs = importAll(contentFiles, "tarifs").sort((a, b) => {
    const aOrder = a.order !== undefined && a.order !== null && a.order !== ""
      ? Number(a.order)
      : Number.MAX_SAFE_INTEGER;
    const bOrder = b.order !== undefined && b.order !== null && b.order !== ""
      ? Number(b.order)
      : Number.MAX_SAFE_INTEGER;

    return aOrder - bOrder || (a.name || "").localeCompare(b.name || "", "fr");
  });
  localTestimonials = importAll(contentFiles, "testimonials");
  localRealisations = importAll(contentFiles, "realisations");
} catch (e) {
  console.log("Erreur lors du chargement des dossiers du CMS");
}

export const tarifs = localTarifs;
// Les avis doivent être validés avant publication. Les anciennes données de
// démonstration restent disponibles dans le CMS mais ne sont pas affichées.
export const testimonials = localTestimonials.filter((item) => item.published === true);
export const realisations = localRealisations;
